export { LinkCard } from './styled';
